var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.deviceClass,attrs:{"id":"app"}},[_c('div',{attrs:{"id":"measure"}}),_c('div',{staticClass:"main-container"},[(_vm.showHeader)?_c('Header'):_vm._e(),_c('router-view',{staticClass:"view"})],1),_c('evolutive-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }